export enum appointmentlistenum {
    ALL_APPOINTMENTS = 0,
    TODAYS_APPOINTMENTS = 1,
    UNCONFIRMED_APPOINTMENTS = 2,
    CONFIRMATION_REQUIRED_APPOINTMENTS = 3,
    ADDITIONAL_REQUEST_APPOINTMENTS = 4,
    RESCHEDULE_REQUESTED_APPOINTMENTS = 5,
    REVIEW_APPOINTMENTS = 6,
    CLOSED_APPOINTMENTS = 7,
    CONFIRMED_APPOINTMENTS = 8,
    URGENT_APPOINTMENTS = 9,
    ALL_UPCOMING_APPOINTMENTS = 10,
    ALL_PAST_APPOINTMENTS = 11,
    PAST_NOT_JOINED = 12,
    COMING_UP = 13,
    CONFIRMED_IN_SESSION = 14,
    UNCONFIRMED_PAST = 15,
    NEEDS_ATTENTION = 16,
    UNCONFIRMED_ISSUES = 17
}